var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcUnchecked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.035.676h2.324c2.561 0 3.941.338 5.186 1.004a6.704 6.704 0 0 1 2.79 2.789c.666 1.245 1.003 2.625 1.003 5.186v2.336c0 2.561-.337 3.94-1.004 5.186a6.704 6.704 0 0 1-2.789 2.79c-1.245.665-2.625 1.003-5.186 1.003h-2.324c-2.561 0-3.94-.338-5.186-1.004a6.704 6.704 0 0 1-2.79-2.789c-.665-1.245-1.003-2.625-1.003-5.186V9.655c0-2.561.338-3.94 1.004-5.186a6.704 6.704 0 0 1 2.789-2.79C6.094 1.015 7.474.677 10.035.677z",
    fill: "#0D0D0D",
    stroke: "#576078",
    strokeWidth: 1.352,
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUnchecked);
export default __webpack_public_path__ + "static/media/ic_unchecked.56c283baaf45cfddc56f0ac5ce0bef36.svg";
export { ForwardRef as ReactComponent };